//const apiUrl = "https://appbackend.metuaa.com"; //https://metuaa-backend.unicotaxi.com
export const apiUrl = "https://dev.appbackend.metuaa.com"; //https://metuaa-backend.unicotaxi.com
const lewooPayApiUrl = "https://dev.api.lewoo.info";//https://dev.api.lewoo.info http://62.171.179.132:3200
const fileUrl = "";

export const CUSTOM_CONSTANTS = {
  API_BASE_URL: apiUrl,
  BASE_CURRENCY: "FCFA",
};

export const API_ENDPOINTS = {
  // Image URL
  FILE_URL: fileUrl,

  // active endpoints

  // GMAP ENDPOINTS
  GMAP_API: "AIzaSyDd66Ag8p05G1rJGHI4J8kQ-yi3sNV7yqw",

  // upload endpoints
  MULTI_IMAGE_FILE_UPLOAD: `${apiUrl}/api/uploads/multiple`,
  SINGLE_IMAGE_FILE_UPLOAD: `${apiUrl}/api/uploads/single`,
  SITE_IMAGE_UPLOAD: `${apiUrl}/api/v1/settings/siteimageupload`,
  IMAGE_UPLOAD_SINGLE: `${apiUrl}/uploads/single`,
  MULTI_FILE_UPLOAD: `${apiUrl}/api/uploads/file/multiple`,
  SINGLE_FILE_UPLOAD: `${apiUrl}/api/uploads/file/single`,

  // Login
  // LOGIN: `${apiUrl}/api/user/login`,
  LOGIN: `${apiUrl}/api/v1/auth/login`,
  PROFILE_IMAGE_UPLOAD: `${apiUrl}/api/user`,

  // Profile
  PROFILE: `${apiUrl}/api/v1/users/auth-user-admin`,
  UPDATE_PROFILE: `${apiUrl}/api/user`,
  UPDATE_PASSWORD: `${apiUrl}/api/user/change-password`,
  GET_USER_DETAILS: `${apiUrl}/api/v1/users/auth-token`,
  UPDATE_USER_PASSWORD: `${apiUrl}/api/user/change-password`,

  //Service fare type
  GET_CREATED_FARE_LIST: `${apiUrl}/api/v1/service/service-fare/fare-created-service`,
  GET_EXCLUDED_FARE_LIST: `${apiUrl}/api/v1/service/service-fare/fare-excluded-service`,
  ADD_SERVICE_FARE: `${apiUrl}/api/v1/service/service-fare`,
  GET_SERVICE_FARE_DETAILS_BY_ID: `${apiUrl}/api/v1/service/service-fare`,
  UPDATE_SERVICE_FARE_DETAILS_BY_ID: `${apiUrl}/api/v1/service/service-fare`,
  DELETE_SERVICE_FARE_BY_ID: `${apiUrl}/api/v1/service/service-fare`,

  //Zone type Service fare
  GET_CREATED_ZONEFARE_LIST: `${apiUrl}/api/v1/service/zone-fare/fare-created-service`,
  GET_EXCLUDED_ZONEFARE_LIST: `${apiUrl}/api/v1/service/zone-fare/fare-excluded-service`,
  ADD_ZONE_FARE: `${apiUrl}/api/v1/service/zone-fare`,
  GET_ZONE_FARE_DETAILS_BY_ID: `${apiUrl}/api/v1/service/zone-fare`,
  UPDATE_ZONE_FARE_DETAILS_BY_ID: `${apiUrl}/api/v1/service/zone-fare`,
  DELETE_ZONE_FARE_BY_ID: `${apiUrl}/api/v1/service/zone-fare`,

  //Ratings
  GET_USERRATINGS_LIST: `${apiUrl}/api/v1/users-ratings`,
  GET_DRIVERRATINGS_LIST: `${apiUrl}/api/v1/drivers/driver-ratings`,
  GET_REVIEWS_LIST: `${apiUrl}/api/v1/reviews`,

  // Dashboard
  DASHBOARD: `${apiUrl}/api/v1/dashboard`,

  // Members
  MEMBER: `${apiUrl}/member/list`,
  UPDATE_ADMIN: `${apiUrl}/update-user-admin/:id`,
  UPDATE_USER: `${apiUrl}/update-user-web/:id`,
  ADD_MEMBER: `${apiUrl}/register`,
  GET_MEMBER_BY_ID: `${apiUrl}/:type/:id`,
  GET_LIST_COUNTS: `${apiUrl}/home`,

  // Settings
  UPDATE_APP_STATE: `${apiUrl}/settings/app-enbd`,
  UPDATE_SMS_STATE: `${apiUrl}/settings/sms-enbd`,
  GET_MASTER_VALUES: `${apiUrl}/settings`,
  UPDATE_MASTER_VALUES: `${apiUrl}/settings/google-key-nd-pv`,
  UPDATE_SITE_SETTIGNS: `${apiUrl}/api/v1/settings`,
  GET_SITE_SETTINGS: `${apiUrl}/api/v1/settings`,
  UPDATE_SITE_SETTINGS: `${apiUrl}/api/v1/settings`,
  GET_PAYMENT_SETTINGS: `${apiUrl}/api/v1/settings/payment`,
  UPDATE_PAYMENT_SETTINGS: `${apiUrl}/api/v1/settings/payment`,
  GET_PLATFORM_SETTINGS: `${apiUrl}/api/v1/settings/platform`,
  UPDATE_PLATFORM_SETTINGS: `${apiUrl}/api/v1/settings/platform`,
  GET_USER_REWARD_SETTINGS: `${apiUrl}/api/v1/settings/userrewards`,
  UPDATE_USER_REWARD_SETTINGS: `${apiUrl}/api/v1/settings/userrewards`,
  GET_BUSINESS_SETTINGS: `${apiUrl}/api/v1/settings/business`,
  UPDATE_BUSINESS_SETTINGS: `${apiUrl}/api/v1/settings/business`,
  GET_LEGAL_SETTINGS: `${apiUrl}/api/v1/settings/legal`,
  UPDATE_LEGAL_SETTINGS: `${apiUrl}/api/v1/settings/legal`,
  GET_METUAA_PROFILE: `${apiUrl}/api/v1/metuaa-profile`,
  CREATE_METUAA_PROFILE: `${apiUrl}/api/v1/metuaa-profile`,
  UPDATE_METUAA_PROFILE: `${apiUrl}/api/v1/metuaa-profile`,
  DELETE_METUAA_PROFILE: `${apiUrl}/api/v1/metuaa-profile`,
  DOWNLOAD_LEGAL_CONTRACT: `${apiUrl}/api/v1/settings/legal/contract`,
  GET_CONTRACTS: `${apiUrl}/api/v1/contracts`,
  GET_MPLUS_SHOP_CATALOG: `${apiUrl}/api/v1/mplus/shop/catalog`,
  GET_PRODUCT_CATALOG: `${apiUrl}/api/v1/product-catalog`,
  MPLUS_STOCK: `${apiUrl}/api/v1/mplus/stock`,
  MPLUS_LOCATIONS: `${apiUrl}/api/v1/mplus/locations`,
  MPLUS_BASE: `${apiUrl}/api/v1/mplus`,
  GET_TEMPLATES: `${apiUrl}/api/v1/templates`,
  GET_PRIVACY_SETTINGS: `${apiUrl}/api/v1/settings/privacy`,
  UPDATE_PRIVACY_SETTINGS: `${apiUrl}/api/v1/settings/privacy`,
  ADD_Banks: `${apiUrl}/api/v1/settings/banks`,
  GET_BANKS_LIST: `${apiUrl}/api/v1/settings/banks`,
  GET_BANK_DETAILS_BY_ID: `${apiUrl}/api/v1/settings/banks`,
  UPDATE_BANK_DETAILS_BY_ID: `${apiUrl}/api/v1/settings/banks`,
  DELETE_BANK_DETAILS_BY_ID: `${apiUrl}/api/v1/settings/banks`,
  ADD_Banks_ACC: `${apiUrl}/api/v1/settings/banksacc`,
  GET_BANKS_LIST_ACC: `${apiUrl}/api/v1/settings/banksacc`,
  GET_BANK_DETAILS_BY_ID_ACC: `${apiUrl}/api/v1/settings/banksacc`,
  UPDATE_BANK_DETAILS_BY_ID_ACC: `${apiUrl}/api/v1/settings/banksacc`,
  DELETE_BANK_DETAILS_BY_ID_ACC: `${apiUrl}/api/v1/settings/banksacc`,

  //Location
  GET_SERVICE_AREA: `${apiUrl}/api/v1/service/service-area`,
  GET_SERVICE_AREA_BY_ID: `${apiUrl}/api/v1/service/service-area`,
  ADD_SERVICE_AREA: `${apiUrl}/api/v1/service/service-area`,
  UPDATE_SERVICE_AREA: `${apiUrl}/api/v1/service/service-area`,
  DELETE_SERVICE_AREA: `${apiUrl}/api/v1/service/service-area`,

  GET_RESTRICTED_SERVICE_AREA: `${apiUrl}/api/v1/service/service-restricted-areas`,
  GET_RESTRICTED_SERVICE_AREA_BY_ID: `${apiUrl}/api/v1/service/service-restricted-areas/:id`,
  ADD_RESTRICT_SERVICE_AREA: `${apiUrl}/api/v1/service/service-restricted-areas`,
  UPDATE_RESTRICT_SERVICE_AREA: `${apiUrl}/api/v1/service/service-restricted-areas`,
  GET_RESTRICTED_DETAILS_BY_ID: `${apiUrl}/api/v1/service/service-restricted-areas`,
  DELETE_RESTRICTED_DETAILS_BY_ID: `${apiUrl}/api/v1/service/service-restricted-areas`,

  //Passengers
  GET_CUSTOMERS_LIST: `${apiUrl}/api/v1/customers`,
  GET_CUSTOMER_DETAILS_BY_ID: `${apiUrl}/api/v1/customers`,
  DELETE_CUSTOMER_DETAILS_BY_ID: `${apiUrl}/api/v1/customers`,
  UPDATE_CUSTOMER_DETAILS_BY_ID: `${apiUrl}/api/v1/customers`,
  ADD_PASSENGERS: `${apiUrl}/api/v1/customers/register`,
  USER_DOCUMENTS_TYPE: `${apiUrl}/api/v1/user-documents/load`,
  DOCUMENTS_TYPE: `${apiUrl}/api/v1/drivers/document-types/load`,
  GET_SERVICE_LIST: `${apiUrl}/api/v1/service/service`,
  GET_PASSENGER_REQUEST_HISTORY: `${apiUrl}/api/v1/customers/user-trips`,
  GET_PASSENGER_REQUEST_HISTORY_BYID: `${apiUrl}/api/v1/customers/user-trip`,
  GET_PASSENGER_TRIP_HISTORY_BYID: `${apiUrl}/api/v1/customers/trip-history`,
  DELETE_PASSENGER_REQUEST_BYID: `${apiUrl}/api/v1/customers/delete-user-trip`,
  GET_PASSENGER_DOCUMENTS_BY_PASSENGER_ID: `${apiUrl}/api/v1/user-documents/users`,

  //Promocode
  ADD_PROMOCODE: `${apiUrl}/api/v1/promocode/add`,
  GET_PROMOCODE_LIST: `${apiUrl}/api/v1/promocode`,
  GET_PROMOCODE_DETAILS_BY_ID: `${apiUrl}/api/v1/promocode`,
  UPDATE_PROMOCODE_DETAILS_BY_ID: `${apiUrl}/api/v1/promocode`,
  DELETE_PROMOCODE_DETAILS_BY_ID: `${apiUrl}/api/v1/promocode`,

  //Drivers
  ADD_DRIVER: `${apiUrl}/api/v1/drivers/web-register`,
  UPDATE_DRIVER: `${apiUrl}/api/v1/drivers`,
  CREATE_DRIVER_RIDE: `${apiUrl}/api/v1/drivers`,
  DELETE_DRIVER: `${apiUrl}/api/v1/drivers/delete-driver-web`,
  UPDATE_DRIVER_RIDE: `${apiUrl}/api/v1/drivers`,
  UPLOAD_VEHICLE_IMAGE: `${apiUrl}/api/v1/drivers/service/vehicleimage`,
  GET_DRIVER_SERVICE_DETAILS: `${apiUrl}/api/v1/drivers/service`,
  UPDATE_DRIVER_SERVICE_STATUS: `${apiUrl}/api/v1/drivers/service/status`,
  DRIVER_ENDPOINT: `${apiUrl}/api/v1/users`,
  DRIVER_DOCUMENTS_TYPE: `${apiUrl}/api/v1/drivers/document-types/load`,
  DRIVER_DOCUMENTS_TYPE_V2: `${apiUrl}/api/v2/drivers/document-types/load`,
  DRIVER_DOCUMENT_TYPES: `${apiUrl}/api/v1/drivers/document-types`,
  LEWOO_PAY_REGISTER: `${lewooPayApiUrl}/api/v1/auth/register`,
  GET_DRIVER_BANK_DETAILS_BY_ID: `${apiUrl}/api/v1/settings/banks/getdriver`,
  UPDATE_DRIVER_BANK_DETAILS_BY_ID: `${apiUrl}/api/v1/settings/banks/updatedriver`,
  GET_DRIVER_DOCUMENTS_BY_DRIVER_ID: `${apiUrl}/api/v1/drivers/driver-documents/driver`,
  DRIVER_DOCUMENT_END_POINT: `${apiUrl}/api/v1/drivers-document`,
  UPDATE_DRIVER_DOCUMENT_END_POINT: `${apiUrl}/api/v1/drivers/driversdoc`,
  UPDATE_PASSENGER_DOCUMENT_END_POINT: `${apiUrl}/api/v1/user-documents`,
  DELETE_DRIVER_DOCUMENT_END_POINT: `${apiUrl}/api/v1/drivers/driversdoc`,
  DELETE_USER_DOCUMENT_END_POINT: `${apiUrl}/api/v1/user-documents`,
  DRIVER_DOCUMENT_UPDATE: `${apiUrl}/api/v1/drivers-document/status`,
  DRIVER_COMPLETE_DETAILS: `${apiUrl}/api/v1/drivers/complete`,
  GET_DRIVER_USER: `${apiUrl}/api/v1/drivers`,
  GET_RIDES_LIST: `${apiUrl}/api/v1/rides`,
  GET_RIDE_WAYPOINT_LIST: `${apiUrl}/api/v1/ride-waypoints`,
  GET_BOOKINGS_LIST: `${apiUrl}/api/v1/bookings`,
  GET_CONVERSATIONS_LIST: `${apiUrl}/api/v1/conversations`,
  GET_MESSAGES_LIST: `${apiUrl}/api/v1/messages`,
  GET_BUS_ROUTES_LIST: `${apiUrl}/api/v1/bus-routes`,
  GET_BUS_TRIPS_LIST: `${apiUrl}/api/v1/bus-trips`,
  GET_PLACES_LIST: `${apiUrl}/api/v1/places`,
  GET_ALL_DRIVER_EARNINGS_LIST: `${apiUrl}/api/v1/drivers/driver-earnings`,
  GET_A_DRIVER_EARNINGS_LIST: `${apiUrl}/api/v1/drivers/driver-earnings/earning-logs`,
  GET_ALL_DRIVER_REWARDS_LIST: `${apiUrl}/api/v1/drivers/driver-earnings/rewards`,
  GET_A_DRIVER_REWARDS_LIST: `${apiUrl}/api/v1/drivers/driver-earnings/reward-logs`,
  GET_A_DRIVERS_CASHOUTRECORDS: `${apiUrl}/api/v1/drivers/driver-earnings/cashoutrecords`,
  UPDATE_A_DRIVERS_CASHOUTRECORDS: `${apiUrl}/api/v1/drivers/driver-earnings/update-cashoutrecords`,
  GET_A_DRIVERS_CASHOUTSHEETS: `${apiUrl}/api/v1/drivers/driver-earnings/cashoutsheets`,
  UPDATE_A_DRIVERS_CASHOUTSHEETS: `${apiUrl}/api/v1/drivers/driver-earnings/update-cashoutsheets`,

  //Vehicles
  GET_VEHICLE_LIST: `${apiUrl}/api/v1/vehicle`,
  ADD_VEHICLE: `${apiUrl}/api/v1/vehicle`,
  GET_VEHICLE_BY_ID: `${apiUrl}/api/v1/vehicle`,
  UPDATE_VEHICLE: `${apiUrl}/api/v1/vehicle`,
  DELETE_VEHICLE: `${apiUrl}/api/v1/vehicle`,
  ASSIGN_DRIVER: `${apiUrl}/api/v1/vehicle/assign-driver`,
  GET_VEHICLE_LEASE_PURCHASES: `${apiUrl}/api/v1/vehicle-lease-purchase`,

  //Service type
  GET_SERVICES: `${apiUrl}/api/v1/service/service`,
  ADD_SERVICES: `${apiUrl}/api/v1/service/service`,
  GET_SERVICES_WITH_FARE_MODEL: `${apiUrl}/api/v1/service/service/withfaremodel`,
  GET_SERVICE_DETAILS_BY_ID: `${apiUrl}/api/v1/service/service`,
  UPDATE_SERVICE_DETAILS_BY_ID: `${apiUrl}/api/v1/service/service`,
  DELETE_SERVICE_BY_ID: `${apiUrl}/api/v1/service/service`,

  //banner template
  GET_BANNERS_LIST: `${apiUrl}/api/v1/banner`,
  GET_BANNERS_DETAILS_BY_ID: `${apiUrl}/api/v1/banner`,
  ADD_BANNERS: `${apiUrl}/api/v1/banner`,
  UPDATE_BANNERS_DETAILS_BY_ID: `${apiUrl}/api/v1/banner`,
  DELETE_BANNERS_BY_ID: `${apiUrl}/api/v1/banner`,

  //Dispatcher
  GET_ALL_DISPATCHERS: `${apiUrl}/api/v1/dispatcher`,
  GET_DISPATCHER_DETAILS_BY_ID: `${apiUrl}/api/v1/dispatcher`,
  UPDATE_DISPATCHER_DETAILS_BY_ID: `${apiUrl}/api/v1/dispatcher`,
  DELETE_DISPATCHER_DETAILS_BY_ID: `${apiUrl}/api/v1/dispatcher`,
  ADD_DISPATCHER: `${apiUrl}/api/v1/dispatcher/register`,
  GET_DRIVERS_AND_SERVICES: `${apiUrl}/api/v1/dispatcher/services_drivers`,
  GET_SELECTED_SERVICE_DRIVERS: `${apiUrl}/api/v1/dispatcher/selected_service_drivers`,
  GET_SELECTED_RIDE_STATUS_DRIVERS: `${apiUrl}/api/v1/dispatcher/selected_status_drivers`,
  CREATE_NEW_RIDE_BY_DISPATCHER: `${apiUrl}/api/v1/dispatcher/create-trip`,
  ASSIGN_NEW_RIDE_BY_DISPATCHER: `${apiUrl}/api/v1/dispatcher/assign-trip`,
  FETCH_NEARBY_DRIVERS: `${apiUrl}/api/v1/dispatcher/nearbydrivers`,
  CANCEL_RIDE_BY_DISPATCHER_OR_ADMIN: `${apiUrl}/api/v1/users-trips/cancelride`,

  //Accountmanager
  GET_ALL_MANAGERS: `${apiUrl}/api/v1/account-manager`,
  GET_MANAGER_DETAILS_BY_ID: `${apiUrl}/api/v1/account-manager`,
  UPDATE_MANAGAER_DETAILS_BY_ID: `${apiUrl}/api/v1/account-manager`,
  DELETE_MANAGER_DETAILS_BY_ID: `${apiUrl}/api/v1/account-manager`,
  ADD_MANAGER: `${apiUrl}/api/v1/account-manager/register`,

  //Subcompany
  GET_ALL_SUBCOMPANY: `${apiUrl}/api/v1/sub-company`,
  GET_ALL_SUBCOMPANY_NAMES: `${apiUrl}/api/v1/sub-company/names`,
  GET_SUBCOMPANY_DETAILS_BY_ID: `${apiUrl}/api/v1/sub-company`,
  UPDATE_SUBCOMPANY_DETAILS_BY_ID: `${apiUrl}/api/v1/sub-company`,
  DELETE_SUBCOMPANY_DETAILS_BY_ID: `${apiUrl}/api/v1/sub-company`,
  ADD_SUBCOMPANY: `${apiUrl}/api/v1/sub-company/register`,

  //Corporate
  GET_CORPORATE: `${apiUrl}/api/v1/user/corporates`,
  GET_ALL_CORPORATE: `${apiUrl}/api/v1/corporates`,
  GET_CORPORATE_DETAILS_BY_ID: `${apiUrl}/api/v1/corporates`,
  UPDATE_CORPORATE_DETAILS_BY_ID: `${apiUrl}/api/v1/corporates`,
  DELETE_CORPORATE_DETAILS_BY_ID: `${apiUrl}/api/v1/corporates`,
  ADD_CORPORATE: `${apiUrl}/api/v1/corporates/register`,
  ADD_GROUPS: `${apiUrl}/api/v1/corporates/add_group`,
  GET_CORPORATE_GRP: `${apiUrl}/api/v1/corporates/grp`,
  GET_CORPORATE_GRP_DETAILS_BY_ID: `${apiUrl}/api/v1/corporates/grp`,
  UPDATE_CORPORATE_GRP_DETAILS_BY_ID: `${apiUrl}/api/v1/corporates/grp`,
  DELETE_CORPORATE_GRP_DETAILS_BY_ID: `${apiUrl}/api/v1/corporates/grp`,
  ADD_EMPLOYEES: `${apiUrl}/api/v1/corporates/add_employee`,
  GET_CORPORATE_EMPLOYEES: `${apiUrl}/api/v1/corporates/emp`,
  GET_CORPORATE_EMPLOYEES_DETAILS_BY_ID: `${apiUrl}/api/v1/corporates/emp`,
  UPDATE_CORPORATE_EMPLOYEES_DETAILS_BY_ID: `${apiUrl}/api/v1/corporates/emp`,
  DELETE_CORPORATE_EMPLOYEES_DETAILS_BY_ID: `${apiUrl}/api/v1/corporates/emp`,

  //Hotel
  GET_ALL_HOTELS: `${apiUrl}/api/v1/hotel`,
  GET_HOTELS_DETAILS_BY_ID: `${apiUrl}/api/v1/hotel`,
  UPDATE_HOTELS_DETAILS_BY_ID: `${apiUrl}/api/v1/hotel`,
  DELETE_HOTELS_DETAILS_BY_ID: `${apiUrl}/api/v1/hotel`,
  ADD_HOTELS: `${apiUrl}/api/v1/hotel/register`,
  CREATE_NEW_RIDE_BY_HOTEL: `${apiUrl}/api/v1/hotel/send/request`,
  GET_UPCOMINGTRIP_LISTS_HOTEL: `${apiUrl}/api/v1/hotel/upcoming_rides`,
  GET_MYTRIP_LISTS_HOTEL: `${apiUrl}/api/v1/hotel/my_trips`,
  CANCEL_UPCOMINGRIDE_BY_HOTEL: `${apiUrl}/api/v1/hotel/cancel_ride`,

  //Triplist
  GET_TRIP_LISTS: `${apiUrl}/api/v1/users-trips`,
  GET_TRIP_LISTS_CORP: `${apiUrl}/api/v1/users-trips/corp`,
  GET_TRIP_LISTS_CORP_DAILY: `${apiUrl}/api/v1/users-trips/corp_daily`,
  GET_TRIP_LISTS_CORP_MONTHLY: `${apiUrl}/api/v1/users-trips/corp_monthly`,
  GET_TRIP_LISTS_CORP_YEARLY: `${apiUrl}/api/v1/users-trips/corp_yearly`,
  GET_FILTERED_TRIP_LISTS: `${apiUrl}/api/v1/users-trips/user-trips-filtered`,
  GET_DRIVERS_INFO: `${apiUrl}/api/v1/users-trips/driversinfo`,
  GET_RIDES_OF_DRIVER: `${apiUrl}/api/v1/users-trips/rides_of_driver`,

  //Wallet
  GET_ALL_USERWALLET: `${apiUrl}/api/v1/wallet/users`,
  GET_ALL_USERWALLET_LOGS: `${apiUrl}/api/v1/wallet/userslog`,
  ADD_WALLET_AMOUNT: `${apiUrl}/api/v1/wallet/addmoney`,
  GET_ALL_DRIVERWALLET: `${apiUrl}/api/v1/wallet/drivers`,
  //GET_ALL_DRIVERWALLET_LOGS:`${apiUrl}/api/v1/wallet/driverslog`,

  //Notifications
  GET_NOTIFICATIONS_LIST: `${apiUrl}/api/v1/notifications`,
  GET_USERS_LIST: `${apiUrl}/api/v1/customers/allusers`,
  DELETE_MULTIPLE_NOTIFICATIONS: `${apiUrl}/api/v1/notifications`,
  SEND_SMS_NOTIFICATIONS: `${apiUrl}/api/v1/notifications/sendsms`,
  SEND_MAIL_NOTIFICATIONS: `${apiUrl}/api/v1/notifications/sendmails`,
  SEND_PUSH_NOTIFICATIONS: `${apiUrl}/api/v1/notifications/sendpushnotifies`,
  FOUNDATION_USERS: `${apiUrl}/api/v1/foundation/users`,
  FOUNDATION_ROLES: `${apiUrl}/api/v1/foundation/roles`,
};

export const ACTION_TYPES = {
  SHOW_SNACKBAR: "SHOW_SNACKBAR",
  HIDE_SNACKBAR: "HIDE_SNACKBAR",
  SHOW_LOADER: "SHOW_LOADER",
  HIDE_LOADER: "HIDE_LOADER",
  MENU_TOGGLE: "MENU_TOGGLE",
  AUTH: "AUTH",
  PROFILE_SETTINGS: "PROFILE_SETTINGS",
  SITE_LOGO: "SITE_LOGO",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  TIMEZONE: "TIMEZONE",
  LATITUDE: "LATITUDE",
  LONGITUDE: "LONGITUDE",
  PROFILE_DETAILS: "PROFILE_DETAILS",
};
